import {
  PairedCostAdjustmentType,
  PairedCostAdjustments,
  PairedCostFeatures,
} from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';
import {
  depreciatedCostAdjustmentsAfterMainDwelling,
  depreciatedCostAdjustmentsBeforeMainDwelling,
  marketAdjustments,
} from '../consts.js';
import { FeaturesAndAdjustments } from '../types.js';
import { getAdjustment } from './getAdjustment.js';
import { getAdjustmentTooltip } from './getAdjustmentTooltip.js';
import { getFeatureValue } from './getFeatureValue.js';

export const makeSimpleValueAndAdjustmentDictionary = (
  context: Tkv2OrderContext,
  compID: string,
): FeaturesAndAdjustments =>
  Object.fromEntries(
    [
      ...marketAdjustments,
      ...depreciatedCostAdjustmentsBeforeMainDwelling,
      ...depreciatedCostAdjustmentsAfterMainDwelling,
    ].map(({ path }) => [
      path,
      {
        value: getFeatureValue(context, compID, path as keyof PairedCostFeatures)?.text,
        adjustment: getAdjustment(context, compID, path as keyof PairedCostAdjustments),
        tooltip: getAdjustmentTooltip(context, compID, path as keyof PairedCostAdjustments),
        summary: context.pairedCostResults.adjustmentSummaries?.[path as PairedCostAdjustmentType],
      },
    ]),
  ) as FeaturesAndAdjustments;
